import { createReduxModule } from "hooks-for-redux";
import { StatusCodes } from "http-status-codes";
import getCompanies, { ICompaniesResponse } from "../../api/get/getCompanies";
import getCountries, { ICountriesResponse } from "../../api/get/getCountries";
import getGenders, {
  IGendersResponse,
} from "../../../common/api/get/getGenders";
import getCustomerProfile, {
  ICustomerProfileResponse,
} from "../../api/get/getCustomerProfile";
import { IIsProfileValidResponse } from "../../api/get/getIsProfileValid";
import getLanguages, { ILanguagesResponse } from "../../api/get/getLanguages";
import getProfile from "../../api/get/getProfile";
import { IProfileResponse } from "../../utils/types";
import { IAddressesResponse } from "../../../common/api/get/getAddresses/getAddresses.types";
import getBusinessAddress from "../../../common/api/get/getAddresses/getBusinessAddress";

export interface IProfileStepData {
  address: IAddressesResponse;
  countries: ICountriesResponse[];
  languages: ILanguagesResponse[];
  companies: ICompaniesResponse[];
  profile: IProfileResponse;
  customerProfile: ICustomerProfileResponse;
  profileValidation: IIsProfileValidResponse;
  genders: IGendersResponse[];
}

const initialState: IProfileStepData = {
  address: {} as IAddressesResponse,
  countries: [],
  languages: [],
  companies: [],
  genders: [],
  profile: {} as IProfileResponse,
  customerProfile: {} as ICustomerProfileResponse,
  profileValidation: {} as IIsProfileValidResponse,
};

export const [
  useProfileStepData,
  { setProfileStepData, setProfileValidationData },
  profileStepDataStore,
] = createReduxModule("profile", initialState, {
  setProfileStepData: (state, data: IProfileStepData) => ({
    ...state,
    ...data,
  }),
  setProfileValidationData: (state, data: IIsProfileValidResponse) => ({
    ...state,
    profileValidation: { ...data },
  }),
});

export const UpdateProfileStepData = async (jwt: string, personId: number) => {
  const addressRes = await getBusinessAddress(jwt, personId);
  const countriesRes = await getCountries(jwt);
  const languagesRes = await getLanguages(jwt);
  const companiesRes = await getCompanies(jwt);
  const profileRes = await getProfile(jwt, personId);
  const customerProfileRes = await getCustomerProfile(jwt, personId);
  const genderRes = await getGenders(jwt);

  if (addressRes?.status !== StatusCodes.OK) return addressRes?.status;
  if (countriesRes?.status !== StatusCodes.OK) return countriesRes?.status;
  if (languagesRes?.status !== StatusCodes.OK) return languagesRes?.status;
  if (companiesRes?.status !== StatusCodes.OK) return companiesRes?.status;
  if (profileRes?.status !== StatusCodes.OK) return profileRes?.status;
  if (genderRes?.status !== StatusCodes.OK) return genderRes?.status;
  if (customerProfileRes?.status !== StatusCodes.OK)
    return customerProfileRes?.status;

  setProfileStepData({
    ...profileStepDataStore.getState(),
    address: addressRes.data,
    countries: [...countriesRes.data],
    languages: [...languagesRes.data],
    companies: [...companiesRes.data],
    profile: profileRes.data,
    genders: [...genderRes.data],
    customerProfile: customerProfileRes.data,
  });

  return StatusCodes.OK;
};
